import { platformOpsApi } from ".";

export interface PasswordResetResponse {
  password: string;
}

export interface PasswordResetAuditDto {
  id: number;
  companyId: number;
  companyName: string;
  databaseLetter: string;
  userName: string;
  requestedBy: string;
  dateChanged: string;
}

export const resetPassword = async (
  serverId: string,
  companyId: number,
  databaseLetter: string,
  username: string,
  companyName: string
): Promise<PasswordResetResponse> => {
  const response = await platformOpsApi.post<PasswordResetResponse>(
    `/v1/express/server/${serverId}/company/${companyId}/database/${databaseLetter}/password`,
    { username, companyName }
  );
  return response.data;
};

export const getPasswordResetAudits = async (): Promise<PasswordResetAuditDto[]> => {
  const response = await platformOpsApi.get<PasswordResetAuditDto[]>("/v1/express/audit/password");
  return response.data;
};
